import { create } from 'zustand';
import { persist, PersistStorage } from 'zustand/middleware'; // Import PersistStorage

interface AuthUser {
  id?: number;
  username: string;
  email?: string;
  first_name?: string;
  last_name?: string;
  is_staff?: boolean;
  is_superuser?: boolean;
}

interface AuthState {
  isAuthenticated: boolean;
  user: AuthUser | null;
  token: string | null;
  login: (user: AuthUser, token: string) => void;
  logout: () => void;
  setToken: (token: string) => void;
}

// Custom storage for Zustand persist to handle localStorage type incompatibility
const customLocalStorage: PersistStorage<AuthState> = {
  getItem: (name) => {
    const item = localStorage.getItem(name);
    return item ? JSON.parse(item) : null;
  },
  setItem: (name, value) => {
    localStorage.setItem(name, JSON.stringify(value));
  },
  removeItem: (name) => {
    localStorage.removeItem(name);
  },
};

const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      user: null,
      token: null,
      login: (user, token) => set({ isAuthenticated: true, user, token }),
      logout: () => set({ isAuthenticated: false, user: null, token: null }),
      setToken: (token) => set({ token }),
    }),
    {
      name: 'auth-storage', // unique name
      storage: customLocalStorage, // use customLocalStorage for persistence
    }
  )
);

export default useAuthStore;
